import { noop } from 'remeda';

const useLightweightCarousel = () => ({
  onViewedEndScreen: noop,
});

export default useLightweightCarousel;
